import styled from 'styled-components';
import themeColors, { type ColorName } from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';

export const CopyBoxWrapper = styled.div<{ $background?: ColorName }>`
  cursor: default;

  display: flex;
  gap: ${themeSpacing.xs2};
  align-items: center;
  justify-content: space-between;

  padding: ${themeSpacing.sm1};

  background-color: ${({ $background }) => ($background ? themeColors[$background] : themeColors.background)};
  border-radius: ${themeSpacing.radiusMedium};
`;

export const TooltipContent = styled.div`
  display: flex;
  justify-content: center;
`;
